import apiClient from "config/api";

const getDashboadKpis = async () => {
  return apiClient.get("/admin/dashboard/kpis");
};

const getCustomersWithFilter = async (startDate, endDate) => {
  return apiClient.get("/admin/dashboard/kpis/plan-distribution", {
    params: { startDate, endDate },
  });
};

const getClosedLandlordsWithFilter = async (startDate, endDate) => {
  return apiClient.get("/admin/dashboard/kpis/closed-landlords", {
    params: { startDate, endDate },
  });
};

const getGrowthDataWithFilter = async (startDate, endDate) => {
  return apiClient.get("/admin/dashboard/kpis/growth", {
    params: { startDate, endDate },
  });
};

const getRevenueDataWithFilter = async (startDate, endDate) => {
  return apiClient.get("/admin/dashboard/kpis/revenue", {
    params: { startDate, endDate },
  });
};

export {
  getDashboadKpis,
  getCustomersWithFilter,
  getClosedLandlordsWithFilter,
  getGrowthDataWithFilter,
  getRevenueDataWithFilter,
};
